<div *ngIf="rows?.length < 1" style="color: #a5addc; display: flex; justify-content: center; align-items: center;  padding: 150px 0;">
  <div style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
    <mat-icon>emoji_emotions</mat-icon>
    <div style="font-size: 16px;">Oops! We cannot display any of your Facts here. We can only show Facts with a start and end date.</div>
  </div>
</div>
<div *ngIf="rows?.length > 0" class="main-container" style="width: 100%" #timelineContainer>
  <div style="display: flex; align-items: center; width: 50%">
    <div style="margin-right: 20px;">
      <mat-button-toggle-group [(ngModel)]="collapseGaps" (change)="refreshTimeline()">
        <mat-button-toggle [value]="false">Overview</mat-button-toggle>
        <mat-button-toggle [value]="true">Collapsed</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="label-control-container" style="flex-grow: 1;">
      <span>Scale</span>
      <mat-slider min="1" max="4" step="0.025" class="lex-mat-slider-gold-and-grey"
                  style="width: 100%" #ngSlider><input matSliderThumb (change)="refreshTimeline()" [(value)]="scale" #ngSliderThumb="matSliderThumb" /></mat-slider>
    </div>
  </div>
  <div style="overflow: auto">
    <div class="timeline-container" [style.width.px]="maxWidth">
      <div style="margin-bottom: 10px;">
        <div *ngIf="collapseGaps" class="collapsed-timeline-ruler">
          <div>{{earliestDate.getFullYear()}}</div>
          <div>{{latestDate.getFullYear()}}</div>
        </div>
        <div *ngIf="!collapseGaps" class="timeline-ruler">
          <div *ngFor="let year of yearsAndTicks; index as i; trackBy: trackYear" class="timeline-year"
               [style.maxWidth.px]="dayWidth * (year.totalDays)" [style.width.px]="dayWidth * (year.totalDays)">
            <span *ngIf="i !== 0" style="transform: translateY(7px)"> | </span>
            <span style="flex-grow: 1; text-align: center;">{{year.year}}</span>
          </div>
        </div>
        <div style="position: relative;">
          <hr/>
          <span class="line arrow-right"></span>
        </div>

      </div>
      <div *ngFor="let row of rows; index as i; trackBy: trackRow" class="timeline-row">
        <div *ngFor="let cell of row; trackBy: trackCell" class="timeline-cell"
             [style.maxWidth.px]="dayWidth * (cell.totalDays)" [style.width.px]="dayWidth * (cell.totalDays)"
             [ngClass]="{empty: !cell.fact }">
          <div *ngIf="cell.fact" class="timeline-cell-content" >
            <div *ngIf="dayWidth * (cell.totalDays) < 180" class="timeline-cell-content-header">
              {{cell.fact.dateStart | date: 'M/d/y'}}
            </div>
            <div *ngIf="dayWidth * (cell.totalDays) > 180" class="timeline-cell-content-header">
              {{cell.fact.dateStart | date: 'M/d/y'}} - {{cell.fact.dateEnd | date: 'M/d/y'}}
            </div>
            <div class="timeline-fact" color="primary" [matTooltip]="createToolTip(cell)" style="cursor: pointer;" (click)="editFact(cell.fact)">
              <div style="display: block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                {{cell.fact.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
